import { Injectable } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';

@Injectable({
  providedIn: 'root'
})
export class IconsService {

  constructor(
    private _matIconRegistry: MatIconRegistry,
    private _domSanitizer: DomSanitizer,
  ) {
  }

  public register(icons: Array<{ label: string, path: string }>): void {
    if (icons && icons.length) {
      icons.forEach((icon: { label: string, path: string }) => {
        this._matIconRegistry.addSvgIcon(
          icon.label,
          this._domSanitizer.bypassSecurityTrustResourceUrl(icon.path),
        );
      });
    }

  }
}
